export default __webpack_public_path__ + "static/media/GraphikLight.532fcbe7.otf";